<template>
  <div class="new-mapping">
    <b-modal ref="mapModalRef" :title="'Add Mapping'" @hide="cancelNewMapping" @shown="focusOnInput" hide-header-close centered>
      <b-container fluid>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.KEY') }}</b-col>
          <b-col>
            <b-form-input type="text" v-model="mapping.key" :placeholder="$t('TEMPLATE.KEY')" ref="fieldKey"></b-form-input>
            <div v-if="mapping.key && !mapping.isKeyUnique" style="color:red">Key must be unique.</div>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.DATA_TYPE') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="listTypes" v-model="mapping.type" placeholder="Mapping Type" @input="handleRequired()">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row v-if="mapping.type == 'date'" class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.DATE_CATEGORY') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="dateCategoryList" v-model="mapping.date_category" placeholder="Select Date Category">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row v-if="mapping.type == 'date'" class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.DATE_FORMAT') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="dateFormatList" v-model="mapping.dateFormat" placeholder="Select Date Format">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.MAPPING_CATEGORY') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="mappingCategories" v-model="mapping.category" placeholder="Mapping Category">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.ORDER_OF_OCCUR') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="orderOptions" v-model="mapping.order" placeholder="Mapping Order">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3" v-if="canExtract">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.EXT') }}</b-col>
          <b-col>
            <b-form-radio-group>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="extractYes" class="custom-control-input" :value="true" v-model="mapping.extract">
                <label class="custom-control-label" for="extractYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="extractNo" class="custom-control-input" :value="false" v-model="mapping.extract">
                <label class="custom-control-label" for="extractNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.EXT_BY_WORDS') }}</b-col>
          <b-col>
            <b-form-radio-group>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="extractByWordsYes" class="custom-control-input" :value="true" v-model="mapping.extract_by_words">
                <label class="custom-control-label" for="extractByWordsYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="extractByWordsNo" class="custom-control-input" :value="false" v-model="mapping.extract_by_words">
                <label class="custom-control-label" for="extractByWordsNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.REDACT_FIELD') }}</b-col>
          <b-col>
            <b-form-radio-group>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="redactFieldYes" class="custom-control-input" :value="true" v-model="mapping.redact_field">
                <label class="custom-control-label" for="redactFieldYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="redactFieldNo" class="custom-control-input" :value="false" v-model="mapping.redact_field">
                <label class="custom-control-label" for="redactFieldNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.SHOW_FIELD') }}</b-col>
          <b-col>
            <b-form-radio-group>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="showFieldYes" class="custom-control-input" :value="true" v-model="mapping.show_field">
                <label class="custom-control-label" for="showFieldYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="showFieldNo" class="custom-control-input" :value="false" v-model="mapping.show_field">
                <label class="custom-control-label" for="showFieldNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.CASE') }}</b-col>
          <b-col>
            <b-form-select :plain="true" :options="caseCategories" v-model="mapping.case" placeholder="Case">
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.SENS_DATA') }}</b-col>
          <b-col>
            <b-form-radio-group>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="sensitiveDataYes" class="custom-control-input" :value="true" v-model="mapping.sensitive_data">
                <label class="custom-control-label" for="sensitiveDataYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="sensitiveDataNo" class="custom-control-input" :value="false" v-model="mapping.sensitive_data">
                <label class="custom-control-label" for="sensitiveDataNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mb-3" v-if="canShowRequired">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.REQ') }}</b-col>
          <b-col>
            <b-form-radio-group>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="requiredNewYes" class="custom-control-input" :value="true" v-model="mapping.required">
                <label class="custom-control-label" for="requiredNewYes">{{ $t('COMMON.YES') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="requiredNewNo" class="custom-control-input" :value="false" v-model="mapping.required">
                <label class="custom-control-label" for="requiredNewNo">{{ $t('COMMON.NO') }}</label>
              </div>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col cols="3" class="modal-label">{{ $t('TEMPLATE.ALIAS') }}</b-col>
          <b-col>
            <multiselect v-model="selectedAliasData" tag-placeholder="Add this as Alias" placeholder="Search or add a tag" :options="aliasOptions" :multiple="true" :taggable="true" @tag="addTag"></multiselect>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="3" class="modal-label">{{ $t('COMMON.DESCRIPTION') }}</b-col>
          <b-col>
            <b-form-textarea v-model="mapping.description" :placeholder="$t('COMMON.DESCRIPTION')">
            </b-form-textarea>
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer" class="w-100 d-flex justify-content-end">
        <b-btn size="sm" class="float-right" variant="secondary mr-1" @click="createNewMapping" :disabled="!mapping.isKeyUnique || (mapping.type == 'date' && !mapping.dateFormat)">{{ $t('COMMON.ADD') }}</b-btn>
        <b-btn size="sm" class="float-right" variant="light" @click="cancelMapping">{{ $t('COMMON.CANCEL') }}</b-btn>
      </div>
    </b-modal>
    <b-modal :title="'New Mapping'" hide-header-close centered ok-only ok-variant="secondary" @ok="clearDrawing" ref="agnetNewMappingModal">
      <p>You are not permitted to access this. Kindly contact administrator</p>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import Vue from 'vue'

export default {
  components: { Multiselect },
  props: ['mappingsKeys', 'showNewMapping', 'orderOptions', 'mappingsOrderValues'],
  data () {
    return {
      mapping: {
        key: null,
        type: null,
        category: 'default',
        order: null,
        case: null,
        description: null,
        required: false,
        extract: true,
        extract_by_words: false,
        redact_field: false,
        show_field: true,
        sensitive_data: false,
        key_alias: [],
        isKeyUnique: false,
        dateFormat: null,
        date_category: null
      },
      mappingCategories: [
        { value: 'default', text: this.$t('DATA_TYPE.DEFAULT') },
        { value: 'block', text: this.$t('DATA_TYPE.BLOCK') }
      ],
      caseCategories: [
        { value: null, text: this.$t('TEMPLATE.SELECT_CASE') },
        { value: 'capitalize', text: this.$t('DATA_TYPE.CAPITALIZE') },
        { value: 'upper_case', text: this.$t('DATA_TYPE.UPPER_CASE') },
        { value: 'lower_case', text: this.$t('DATA_TYPE.LOWER_CASE') }
      ],
      listTypes: [
        { value: null, text: this.$t('TEMPLATE.SELECT_DATA_TYPE') },
        { value: 'alpha', text: this.$t('DATA_TYPE.ALPHA') },
        { value: 'alphanumeric', text: this.$t('DATA_TYPE.ALPHANUM') },
        { value: 'alphanumeric_with_space', text: this.$t('DATA_TYPE.ALPHANUMSPC') },
        { value: 'numeric_with_decimal', text: this.$t('DATA_TYPE.NUMERICDEC') },
        { value: 'checkbox', text: this.$t('DATA_TYPE.CHECKBOX') },
        { value: 'city', text: this.$t('DATA_TYPE.CITY') },
        { value: 'cod', text: 'COD' },
        { value: 'date', text: this.$t('DATA_TYPE.DATE') },
        { value: 'email', text: 'Email' },
        { value: 'fax', text: 'Fax' },
        { value: 'npi', text: 'NPI' },
        { value: 'numeric', text: this.$t('DATA_TYPE.NUMERIC') },
        { value: 'phone', text: 'Phone' },
        { value: 'signature', text: 'Signature' },
        { value: 'state', text: this.$t('DATA_TYPE.STATE') },
        { value: 'text', text: this.$t('DATA_TYPE.TEXT') },
        { value: 'zip', text: 'ZIP' }
      ],
      dateFormatList: [
        { value: null, text: this.$t('TEMPLATE.SELECT_DATE_FORMAT') },
        { value: 'dd mm yyyy', text: 'dd mm yyyy' },
        { value: 'mm dd yyyy', text: 'mm dd yyyy' },
        { value: 'yyyy mm dd', text: 'yyyy mm dd' },
        { value: 'yyyy dd mm', text: 'yyyy dd mm' }
      ],
      dateCategoryList: [
        { value: 'normal_date', text: 'Normal Date' },
        { value: 'dob', text: 'DOB' },
        // { value: 'expire_date', text: 'Expiration Date' },
        { value: 'future_date', text: 'Future Date' }
      ],
      canExtract: true,
      canShowRequired: false,
      aliasOptions: [],
      selectedAliasData: [],
      requiredNATypes: [ undefined, null ]
    }
  },
  watch: {
    showNewMapping: function () {
      if (this.showNewMapping) {
        if (this.isAdminRole) {
          this.resetData()
          this.mapping.order = this.orderOptions.length
          this.$refs.mapModalRef.show()
        } else {
          this.$refs.agnetNewMappingModal.show()
        }
      } else {
        this.$refs.mapModalRef.hide()
      }
    },
    'mapping.key': function (key) {
      this.mapping.isKeyUnique = key ? (this.mappingsKeys.indexOf(key.toLowerCase().replace(/\s/g, '')) === -1) : false
    },
    'mapping.type': function (type) {
      if (type === 'date') {
        this.mapping.date_category = 'normal_date'
        Vue.toasted.show('Date Category auto selected to Normal Date', { type: 'info' })
      } else {
        this.mapping.date_category = null
      }
    }
  },
  computed: {
    ...mapGetters(['isAdminRole'])
  },
  methods: {
    clearDrawing () {
      this.$refs.agnetNewMappingModal.hide()
      this.$emit('cancelled')
    },
    focusOnInput () {
      this.$refs.fieldKey.focus()
    },
    resetData () {
      this.mapping.key = null
      this.mapping.type = null
      this.mapping.category = 'default'
      this.mapping.order = null
      this.mapping.case = null
      this.mapping.description = null
      this.mapping.required = false
      this.mapping.extract = true
      this.mapping.extract_by_words = true
      this.mapping.redact_field = true
      this.mapping.show_field = true
      this.mapping.sensitive_data = false
      this.mapping.key_alias = []
      this.mapping.dateFormat = null
      this.mapping.date_category = null
      this.aliasOptions = []
      this.selectedAliasData = []
    },
    createNewMapping () {
      this.mapping.key_alias = this.selectedAliasData
      this.$emit('created', this.mapping)
    },
    cancelMapping () {
      this.$refs.mapModalRef.hide()
      this.$emit('cancelled')
    },
    cancelNewMapping () {
      this.$emit('cancelled')
    },
    handleRequired () {
      this.dateFormat = null
      if (this.mapping.type === 'signature') {
        this.mapping.required = true
        this.canShowRequired = true
        this.canExtract = true
      } else if (this.requiredNATypes.includes(this.mapping.type)) {
        this.mapping.required = false
        this.canShowRequired = false
      } else {
        this.mapping.required = false
        this.canShowRequired = true
        this.canExtract = true
      }
    },
    addTag (newTag) {
      this.selectedAliasData.push(newTag)
      this.aliasOptions.push(newTag)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/templates/newMapping.vue